import { render, staticRenderFns } from "./commonHeader.vue?vue&type=template&id=9ca7ff30&scoped=true"
import script from "./commonHeader.vue?vue&type=script&lang=js"
export * from "./commonHeader.vue?vue&type=script&lang=js"
import style0 from "./commonHeader.vue?vue&type=style&index=0&id=9ca7ff30&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ca7ff30",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/hybrid-app/ph-refusaldrainage-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ca7ff30')) {
      api.createRecord('9ca7ff30', component.options)
    } else {
      api.reload('9ca7ff30', component.options)
    }
    module.hot.accept("./commonHeader.vue?vue&type=template&id=9ca7ff30&scoped=true", function () {
      api.rerender('9ca7ff30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/commonHeader.vue"
export default component.exports